import styled from '@emotion/styled';

export const ActionsCell = styled.div`
  display: flex;
  gap: 0.5em;
  justify-content: center;
`;
